import { render, staticRenderFns } from "./RefusedAppointment.vue?vue&type=template&id=a706d91a&"
import script from "./RefusedAppointment.vue?vue&type=script&lang=ts&"
export * from "./RefusedAppointment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports